import { Form, Formik } from 'formik';
import * as bd from 'react-basic-design';
import { SmsTypeDTO } from '../../../api/sms-type-api';
import SvgClose from '../../../assets/icons/Close';
import SvgDelete from '../../../assets/icons/Delete';
import SvgSave from '../../../assets/icons/Save';
import { BasicModal } from '../../../components/basic/basic-modal';
import { T } from '../../../components/basic/text';
import { yup } from '../../../components/basic/yup';
import { FormikTextField } from '../../../components/formik';

interface SaveSmsTypeModalProps {
    show: boolean;
    allowEdit: boolean;
    selectedSmsType?: SmsTypeDTO;
    onHide: () => void;
    onSave: (values: SmsTypeDTO) => void;
    onDelete?: (smsType: SmsTypeDTO) => void;
}

export function SaveSmsTypeModal({
    show,
    allowEdit,
    selectedSmsType,
    onHide,
    onSave,
    onDelete,
}: SaveSmsTypeModalProps) {
    const SmsTypeSchema = yup.object().shape({
        id: yup.string().required(' '),
        title: yup.string().required(' '),
    });

    const defaultValues: SmsTypeDTO = {
        id: selectedSmsType ? selectedSmsType.id : '',
        title: selectedSmsType ? selectedSmsType.title : '',
    };

    if (!show) return <></>;

    return (
        <Formik initialValues={defaultValues} validationSchema={SmsTypeSchema} onSubmit={onSave}>
            {formik => (
                <BasicModal
                    show={show}
                    onHide={onHide}
                    size="xl"
                    title={
                        <bd.Flex className="w-100" align="center" content="between">
                            <T>{selectedSmsType ? 'edit-sms-type' : 'new-sms-type'}</T>
                            <bd.Flex align="center" gap={2}>
                                <bd.Button
                                    variant="icon"
                                    size="sm"
                                    onClick={formik.submitForm}
                                    disabled={!allowEdit}
                                >
                                    <SvgSave />
                                </bd.Button>
                                {selectedSmsType && onDelete && (
                                    <bd.Button
                                        disabled={!allowEdit}
                                        variant="icon"
                                        color="secondary"
                                        size="sm"
                                        onClick={() => onDelete(selectedSmsType)}
                                    >
                                        <SvgDelete />
                                    </bd.Button>
                                )}
                                <bd.Button
                                    variant="icon"
                                    color="secondary"
                                    size="sm"
                                    onClick={onHide}
                                >
                                    <SvgClose />
                                </bd.Button>
                            </bd.Flex>
                        </bd.Flex>
                    }
                >
                    <Form>
                        <bd.Flex align="center" wrap>
                            <FormikTextField
                                label="id"
                                name="id"
                                readOnly={!allowEdit || !!selectedSmsType}
                                width="11rem"
                                handleEnter
                            />

                            <FormikTextField
                                label="title"
                                name="title"
                                readOnly={!allowEdit}
                                width="11rem"
                                handleEnter
                            />
                        </bd.Flex>
                    </Form>
                </BasicModal>
            )}
        </Formik>
    );
}
